var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        placeholder: "请选择",
        clearable: "",
        filterable: "",
        disabled: _vm.disabled,
      },
      on: { change: _vm.select },
      model: {
        value: _vm.selectedValue,
        callback: function ($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.Id,
        attrs: {
          label: `${item.PB_StorArea?.Name}/${item.PB_Rack?.Name}/${item.Name}`,
          value: item.Id,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }